import styled, { css } from 'styled-components';
import Checkbox from '~/src/components/form-components/checkbox/checkbox';
import { rem } from '~/src/helpers/rem-converter.helper';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { MAX_1279, MAX_767 } from '~/src/styles/tokens/break-points';
import { mediaQuery } from '~/src/styles/mixins';
import { CheckboxProps } from '~/src/components/form-components/checkbox/checkbox.types';

export const CheckboxesMainContainer = styled.div<{ width?: string }>`
    width: ${rem(320)};
    height: fit-content;
    gap: ${rem(32)};
    flex-direction: column;

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            width: ${rem(296)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            width: 100%;
        `,
    )};
`;

export const CheckboxesGroupContainer = styled.div`
    width: 100%;
    flex-direction: column;
`;

export const CheckboxesContainer = styled.div`
    max-width: calc(100% - ${rem(25)});
    gap: ${rem(16)};
    flex-direction: column;
    padding-left: ${rem(32)};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            padding-left: 0;
        `,
    )};
`;

export const CheckboxWrap = styled(Checkbox)<CheckboxProps>`
    width: fit-content;
`;

export const GroupTitleContainer = styled.div`
    align-items: center;
    gap: ${rem(8)};
    margin-bottom: ${rem(16)};
`;

export const TitleGroup = styled.h4`
    ${FONTS.compact.medium.size17};
`;

export const LabelComponent = styled.div`
    position: relative;
    align-items: center;
`;

export const LabelTextOuter = styled.span`
    margin-right: ${rem(4)};
    vertical-align: text-top;
`;

export const TooltipContainer = styled.span`
    display: inline-flex;
    align-items: center;
`;

export const LastWordProductName = styled.span`
    margin-right: ${rem(8)};
`;
